import axios from 'axios';

let basicAuthInterceptor = null;

//
// Removes the Interceptor used to Add Basic Authentication to the headers
// (if the Interceptor exists).
//
function removeBasicAuthInterceptor() {
  if (basicAuthInterceptor !== null) {
    axios.interceptors.request.eject(basicAuthInterceptor);
    basicAuthInterceptor = null;
  }
}

//
// Adds an Interceptor used to Add Basic Authentication to the headers for each HTTP request.
// - We first remove the Interceptor if it should already exist, because if it is there, this
//   will add a second one (it does not overwrite the existing one) and we will have more
//   than one executing.
// - We do not add the Authentication if it already exists for a specific Request. This allows
//   a Request to over-ride the values if needed.
//
function addBasicAuthInterceptor(username, password) {
  removeBasicAuthInterceptor();
  basicAuthInterceptor = axios.interceptors.request.use((config) => {
    if (!config.auth) {
      return { ...config, auth: { username, password } };
    }
    return config;
  },
  (error) => Promise.reject(error));
}

export default {

  //
  // Automatically authenticate the user if they were authenticated previously.
  // - Previous signin information will be saved in Local Storage.
  //
  autoAuthenticate() {
    if (localStorage.authenticationInfo) {
      const authenticationInfo = JSON.parse(localStorage.authenticationInfo);
      return this.authenticate(authenticationInfo.username, authenticationInfo.password).then(() => true).catch(() => false);
    }
    return Promise.resolve(false);
  },

  //
  // Authenticates the user using Basic Authentication.
  // - If successful, an Interceptor is set up so that all future requests append the
  //   correct Authentication headers (until the User signs out).
  //
  authenticate(username, password) {
    return axios.head('/users/current/authentication', { auth: { username, password } }).then(() => {
      localStorage.authenticationInfo = JSON.stringify({ username, password });
      addBasicAuthInterceptor(username, password);
    });
  },

  //
  // Replaces the authenticated User's Credentials, for example, if the Password of
  // the User changes.
  // - The Interceptor that was set up so that all future requests append the
  //   correct Authentication headers is re-added so that it uses the new
  //   Credentials.
  //
  replaceCredentials(username, password) {
    addBasicAuthInterceptor(username, password);
  },

  //
  // Unauthenticates the user.
  // - The Interceptor (set up when the User authenticated) is removed so that all future
  //   requests will no longer be sent with the Authentication headers.
  //
  unauthenticate() {
    localStorage.removeItem('authenticationInfo');
    removeBasicAuthInterceptor();
  },

};
